import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeroSection from '@/components/landing/HeroSection';
import VideoScrollSection from '@/components/landing/VideoScrollSection';
import NotOfficeSection from '@/components/landing/NotOfficeSection';
import BenefitsSection from '@/components/landing/BenefitsSection';
import JobsSection from '@/components/landing/JobsSection';
import QuizCTASection from '@/components/landing/QuizCTASection';
import ChatCTASection from '@/components/landing/ChatCTASection';
import ScrollToTop from '@/components/ScrollToTop';

const Index = () => {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <VideoScrollSection />
      <NotOfficeSection />
      <BenefitsSection />
      <JobsSection />
      <QuizCTASection />
      <ChatCTASection />
      <Footer />
      <ScrollToTop />
    </main>
  );
};

export default Index;
